import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { NbButton, NbInput } from "../components/nb";
import { Heart } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-6">
          <img src="/logo.png" alt="qrcupid" className="h-20 w-auto" />
        </Link>
        <div className="bg-white nb-border-thick nb-shadow-lg p-8">
          <h1 className="font-head font-black text-3xl tracking-tight mb-1">Welcome back</h1>
          <p className="text-gray-600 font-medium mb-6">Log in to your account.</p>
          {error && <div data-testid="login-error" className="bg-[#EF4444] text-white nb-border p-3 mb-4 text-sm font-bold">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-head font-bold text-sm uppercase">Email</label>
              <NbInput data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" placeholder="you@example.com" />
            </div>
            <div>
              <label className="font-head font-bold text-sm uppercase">Password</label>
              <NbInput data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" placeholder="••••••••" />
            </div>
            <div className="text-right"><Link to="/forgot-password" className="text-sm font-bold text-[#8B1E3F] hover:underline">Forgot password?</Link></div>
            <NbButton type="submit" data-testid="login-submit" disabled={loading} className="w-full">{loading ? "Logging in..." : "Log In"}</NbButton>
          </form>
          <p className="text-center text-sm font-medium mt-6">No account? <Link to="/register" className="font-bold text-[#8B1E3F] hover:underline">Join free</Link></p>
        </div>
      </div>
    </div>
  );
}
